import React, { useState } from 'react';
import ManageTeams from './settings/ManageTeams';
import TrackSettings from './settings/TrackSettings';
import RiskSettings from './settings/RiskSettings';
import BrandSettings from './settings/BrandSettings';
import Employees from './Employees';

const SECTIONS = [
  {
    key: 'teams', label: 'Manage Teams',
    icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
  },
  {
    key: 'employees', label: 'Manage Employees',
    icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
  },
  {
    key: 'track', label: 'Track Settings',
    icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="14" y2="12"/><line x1="4" y1="18" x2="18" y2="18"/></svg>
  },
  {
    key: 'risk', label: 'Risk User Settings',
    icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
  },
  {
    key: 'brand', label: 'Rebrand Settings',
    icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M4.93 4.93a10 10 0 0 0 0 14.14"/></svg>
  },
];

const PAGES = { teams: ManageTeams, employees: Employees, track: TrackSettings, risk: RiskSettings, brand: BrandSettings };

export default function Settings() {
  const [section, setSection] = useState('teams');
  const Page = PAGES[section];

  return (
    <div style={{ display: 'flex', gap: 0, minHeight: 'calc(100vh - 48px)', margin: '-24px' }}>
      {/* Settings sidebar */}
      <div style={{ width: 220, background: '#fff', borderRight: '1px solid var(--border)', padding: '20px 0', flexShrink: 0 }}>
        <div style={{ padding: '0 16px 16px', fontWeight: 700, fontSize: '1.1rem', borderBottom: '1px solid var(--border)', marginBottom: 8 }}>Settings</div>
        {SECTIONS.map(sec => (
          <button
            key={sec.key}
            onClick={() => setSection(sec.key)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 16px',
              background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.875rem',
              color: section === sec.key ? 'var(--primary)' : 'var(--text)',
              fontWeight: section === sec.key ? 600 : 400,
              borderLeft: section === sec.key ? '3px solid var(--primary)' : '3px solid transparent',
              textAlign: 'left',
            }}
          >
            <span style={{ color: section === sec.key ? 'var(--primary)' : 'var(--muted)' }}>{sec.icon}</span>
            {sec.label}
          </button>
        ))}
      </div>

      {/* Settings content */}
      <div style={{ flex: 1, padding: 24, overflowY: 'auto' }}>
        <Page />
      </div>
    </div>
  );
}
